import { observable, toJS, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';

class CalendarEvent extends DomainObject {
  title;
  start;
  end;
  allDay;
  extendedProps;

  constructor(other) {
    super();

    makeObservable(this, {
      title: observable,
      start: observable,
      end: observable,
      allDay: observable,
      extendedProps: observable
    });

    this.merge(other);
  }

  toFullCalendarEvent() {
    return {
      ...toJS(this),
      backgroundColor: this.backgroundColor,
      textColor: this.textColor,
      borderColor: this.borderColor,
      extendedProps: {
        ...this.extendedProps,
        canViewDetails: this.canViewDetails || false
      }
    };
  }
}

export default CalendarEvent;
